export default __webpack_public_path__ + "static/media/platform-support.d32fcd25.png";